import src from "IMAGE";
export default { src, width: 335, height: 59, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AC6dDdouVARkUU4AOk5LADhOSwA5TUoAOVhVAEFAPgAqixoHf1OyWuQAAAAASUVORK5CYII="};
